//用户中心
var shopDetailObj = {
  model: function () {

  },

  initTopBarTabs: function(){
    var _this = this;

    var touchTabs = new TouchTabs('.topbar-tabs', {
      seledClass: 'seld',
      hookfunction: function(t){
        // console.log(t);
        if(t === 'product'){
          _this.scrollToClass('.swiper-container-product-detail');
        }else if(t === 'comment'){
          _this.scrollToClass('.component-commnet');
        }else if(t === 'detail'){
          _this.scrollToClass('.product-detail-content');
        }else if(t === 'recommend'){
          _this.scrollToClass('.article_interest_goods');
        }
      },
      isReloc: false
    });

    //监听滚动
    addEvent(window,'scroll',function(){
      //取得各模块距顶高度
      var topbarH = document.querySelector('.topbar').clientHeight;
      var productTop = document.querySelector('.swiper-container-product-detail').offsetTop - topbarH;
      var commentTop = document.querySelector('.component-commnet').offsetTop - topbarH;
      var detailTop = document.querySelector('.product-detail-content').offsetTop - topbarH;
      var recommendTop = document.querySelector('.article_interest_goods').offsetTop - topbarH;

      //当前高度
      var scrtop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      // console.log(scrtop)
      // if(scrtop < commentTop){
      //   touchTabs('', 1);
      // }
      // if(scrtop >= commentTop && scrtop < detailTop){
      //   touchTabs('', 2);
      // }
      // if(scrtop >= detailTop && scrtop < recommendTop){
      //   touchTabs('', 3);
      // }
      // if(scrtop >= recommendTop){
      //   touchTabs('', 4);
      // }

      if(scrtop < recommendTop){
        touchTabs('', 1);
      } else if(scrtop >= recommendTop && scrtop < commentTop){
        touchTabs('', 2);
      } else if(scrtop >= commentTop && scrtop < detailTop){
        touchTabs('', 3);
      }else if(scrtop >= detailTop || scrtop + documentClientHeight + 100 >=  documentHeight){
        touchTabs('', 4);
      }
    });


  },

  //调到该样式的地址
  scrollToClass: function (className) {
    var offsetTop = document.querySelector(className).offsetTop;
    var topbarH = document.querySelector('.topbar').clientHeight;
    scrollAnimation(document.scrollingElement.scrollTop,offsetTop - topbarH);
  },

  //

  //产品轮播图视频
  initVideoEvent: function () {

    //swiper
    var shopDetail = new Swiper ('.swiper-container-product-detail', {
      // initialSlide :1,
      direction: 'horizontal', // 垂直切换选项
      slidesPerView: 'auto',
      // centeredSlides: true,
      // loop: true, // 循环模式选项
      observer:true,//修改swiper自己或子元素时，自动初始化swiper
      observeParents:true,//修改swiper的父元素时，自动初始化swiper

      autoplay: {
        delay: 3000,
        disableOnInteraction: false, //用户操作之后停止自动滑动
      },

      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
      },

      on: {
        //简体翻页事件
        slideChangeTransitionStart:function () {
          var videoContentELs = document.querySelectorAll('.swiper-content-video');
          videoContentELs.forEach(function (vidoeItem) {
            vidoeItem.querySelector('video').classList.add('hide');
            vidoeItem.querySelector('video').pause();
            vidoeItem.querySelector('img').classList.remove('hide');
            vidoeItem.querySelector('.shop-playicon').classList.remove('hide');
            shopDetail.autoplay.start();
            // 行为记录
            userAction.playProductVideo();
          });
        }
      }
    });

    //视频
    var videoContentEls = document.querySelectorAll('.swiper-content-video');
    if(videoContentEls.length > 0){
      videoContentEls.forEach(function (item) {
        item.addEventListener('click', function (e) {
          e.currentTarget.querySelector('video').classList.remove('hide');
          e.currentTarget.querySelector('video').play();
          e.currentTarget.querySelector('img').classList.add('hide');
          e.currentTarget.querySelector('.shop-playicon').classList.add('hide');
          shopDetail.autoplay.stop();
        });
      });
    }
  },

  //弹出评论
  commentReply: function () {
    window.postMessage({type:'moreReply'}, '*');
  },

  //产品数量控制
  shopNum:null,
  initProductNum: function () {

    if(document.querySelector('.shop-num-box')){
      this.shopNum = new ProductNumCtr('.shop-num-cut', '.shop-num', '.shop-num-add');
    }
  },

  //获取点赞和评论数
  getCollec: function () {
    getCollectionStatus(articleId, document.querySelector('.nav-item-collect'), function (data) {
      //设置评论数
      document.querySelector('.comment-num').textContent = data[0].commentCount;
      //设置点赞数
      document.querySelector('.favorite-num').textContent = data[0].collectCount;
    });

    //此处待优化
    getCollectionStatus(articleId, document.querySelector('.price-favorite-collect'), function (data) {});
  },

  //批量议价单
  openBargainDialog: function(productId, productName, productDesc, productSale, productPrice, productImgUrl) {
    var _this = this;
    userRecode({behaviorType: '批量议价', behaviorResult: productName, entrance: productName + '/' + productId});
    msg.batchDialog({
      productId: productId || '',
      productName: productName || '',
      productDesc: productDesc || '',
      productSale: productSale || '',
      productPrice: productPrice || '',
      productImgUrl: productImgUrl || '',
      productNum: _this.shopNum.getNum() || ''
    });
  },

  //商城采购单
  openPurchaseDialog: function (productId, productName, productDesc, productSale, productPrice, productImgUrl, productNum) {
    gio('track', 'ibuyClick');
    var _this = this;
    userRecode({behaviorType: '商城采购单', behaviorResult: productName, entrance: productName + '/' + productId});
    msg.batchDialog({
      productId: productId || '',
      productName: productName || '',
      productDesc: productDesc || '',
      productSale: productSale || '',
      productPrice: productPrice || '',
      productImgUrl: productImgUrl || '',
      productNum: productNum || _this.shopNum.getNum() || ''
    }, window.cateData.purchaseForm);
  },

  //产品选型
  chooseType: function(productName){
    userRecode({behaviorType: '产品选型', behaviorResult: productName});
    gio('track', 'productTypeClick', {'ibuyEntrancePageTitle': document.title, 'ibuyEntrancePageURL': document.URL})

  },

  //浏览规格部分5秒钟弹出 pop
  browseAttrAction:function(){
    var timer = null; //计时器
    var isRuning = false; //计时器是否在运行
    function setTimer() {
      if(isRuning){
        return;
      }
      isRuning = true;
        smartRec.showCustomerServicePopup('BrowseSpe');
      timer = setTimeout(function () {
        console.log("浏览参数区5秒");
        clearTimer();
      }, 5000)
    }

    function clearTimer() {
      if(!timer){
        return;
      }
      clearTimeout(timer);
      timer = null;
      isRuning = false;
    }

    var attEl = document.querySelector('.product-detail-spe');

    //注册滚动事件
    addEvent(window,'scroll',function(){
      if(isElementInViewport(attEl)){
        setTimer();
      }else{
        clearTimer();
      }
    });

    function isElementInViewport(el) {
      //获取元素是否在可视区域
      var rect = el.getBoundingClientRect();
      var topbarH = document.querySelector('.topbar').clientHeight;
      var navH = document.querySelector('.bottombox').clientHeight;
      return (
          (rect.top >= topbarH && rect.top <= ((window.innerHeight || document.documentElement.clientHeight) - navH)) ||
          (rect.bottom <= ((window.innerHeight || document.documentElement.clientHeight) - navH) && rect.bottom >= topbarH )
      );
    }
  },

  init: function () {
    this.model();
    this.initTopBarTabs();
    this.initVideoEvent();
    this.initProductNum();
    this.getCollec();
    this.browseAttrAction();
  }
};
